module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-00.2@2x.30a09e90.jpg";